class EmailSignupBlock extends HTMLElement {
  constructor() {
    super();
    this.lastButtonWidth = 0;
    this.observer = undefined;

    this.adjustInputPadding = this.adjustInputPadding.bind(this);
    this.trackLeadEvent = this.trackLeadEvent.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('.email-signup__button--integrated');
    this.input = this.querySelector('.email-signup__input');
    this.inputGroup = this.querySelector('.email-signup__input-group');
    this.form = this.querySelector('form');

    const isTextButton = this.button && this.button.classList.contains('email-signup__button--text');

    // Existing padding logic
    if (this.button && this.input && this.inputGroup && isTextButton) {
      this.adjustInputPadding();

      this.observer = new ResizeObserver(() => {
        this.adjustInputPadding();
      });
      this.observer.observe(this.button);

      if ('fonts' in document) {
        document.fonts.ready.then(() => {
          this.adjustInputPadding();
        });
      }
    }

    // --- New: track Facebook Lead ---
    if (this.form) {
      this.form.addEventListener('submit', this.trackLeadEvent);
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.form) {
      this.form.removeEventListener('submit', this.trackLeadEvent);
    }
  }

  adjustInputPadding() {
    if (!this.button || !this.inputGroup) return;

    const buttonWidth = this.button.offsetWidth;

    if (buttonWidth !== this.lastButtonWidth) {
      this.lastButtonWidth = buttonWidth;
      this.inputGroup.style.setProperty('--button-actual-width', `${buttonWidth}px`);
    }
  }

  trackLeadEvent(event) {
    // Wait a short time to allow Shopify to process the form
    setTimeout(() => {
      if (this.input && this.input.value && window.fbq) {
        fbq('track', 'Lead', { email: this.input.value });
        console.log('Facebook Lead fired for', this.input.value);
      }
    }, 500);
  }
}

if (!customElements.get('email-signup-block')) {
  customElements.define('email-signup-block', EmailSignupBlock);
}
